import React, { ReactNode, useMemo, useState } from 'react';

export enum ResultsView {
  LIST = "list",
  GRID = "grid"
}

interface ResultsViewContext {
  value: ResultsView
  set: (view: ResultsView) => void;
};

export const ResultsViewContext = React.createContext<ResultsViewContext>({
  value: ResultsView.LIST,
  set: () => undefined
});

export const ResultsViewContextProvider = ({ children }: {children?: ReactNode }) => {
  const [ view, setView ] = useState<ResultsView>(ResultsView.LIST);

  const set = (view: ResultsView) => setView(view);

  const ResultsViewContextValue: ResultsViewContext = useMemo(() => ({
    value: view,
    set
  }), [view, set]);

  return (
    <ResultsViewContext.Provider value={ResultsViewContextValue}>
      { children }
    </ResultsViewContext.Provider>
  );
};
